<mat-chip-grid #tagGrid aria-label="Tags" [formControl]="noteTagsCtrl">
  <ng-container *ngFor="let tag of activityTags()">
    <mat-chip-row (removed)="removeTag($event)" matTooltip="{{ tag }}">
      {{ tag }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  </ng-container>
  <input
    placeholder="{{ 'ACTIVITY_LOGGER.ADD_TAGS' | translate }}"
    [matChipInputFor]="tagGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
    [matAutocomplete]="tagAutocomplete"
    [formControl]="tagsCtrl"
    (matChipInputTokenEnd)="addNewTag($event)"
  />
</mat-chip-grid>
<mat-autocomplete #tagAutocomplete="matAutocomplete" (optionSelected)="selectedTag($event)">
  <ng-container *ngIf="filteredTags$ | async as tags">
    <mat-option *ngFor="let tag of tags" [value]="tag">
      {{ tag }}
    </mat-option>
  </ng-container>
</mat-autocomplete>
